import React, { useState } from "react";

import TopMenu from "components/Home/Utils/TopMenu";
import MarketOverviewContainer from "containers/Market/MarketOverview";
import MarketJobsContainer from "containers/Market/Jobs/Jobs";
import MarketBlueprintsContainer from "containers/Market/Blueprints/Blueprints";
import MarketDatasetsContainer from "containers/Market/Datasets/Datasets";
import MarketManagementContainer from "containers/Market/Management/Management";

import MarketConsultantsContainer from "containers/Market/Consultants/MarketConsultants";
import CreateConsultantModalContainer from "containers/Market/Consultants/CreateConsultantModal";
import CreateJobModal from "containers/Market/Jobs/CreateJobModal";

import marketLogo from "images/marketplaceLogo.png";
import styles from "./style.module.css";

const Market = (props) => {
  const typeOptions = ["overview", "hire consultants", "job postings", "find blueprints", "find data", "manage jobs"];
  const menuTypeOptions = typeOptions.map((text) => ({ text }));

  const { menuType, updateMenuType, hideSearch, hideNavbar } = props;

  return (
    <div className={styles.marketContainer}>
      {!hideNavbar && (
        <div className={styles.marketHeader}>
          <TopMenu
            options={menuTypeOptions}
            selectHandler={updateMenuType}
            selected={menuType}
            searchHandler={undefined}
          ></TopMenu>
        </div>
      )}
      <div className={styles.marketBodyContainer}>
        {menuType === "overview" ? (
          <MarketOverviewContainer setType={updateMenuType} />
        ) : menuType === "hire consultants" ? (
          <MarketConsultantsContainer type={menuType} hideSearch={hideSearch} />
        ) : menuType === "job postings" ? (
          <MarketJobsContainer type={menuType} hideSearch={hideSearch} />
        ) : menuType === "find blueprints" ? (
          <MarketBlueprintsContainer type={menuType} hideSearch={hideSearch} />
        ) : menuType === "find data" ? (
          <MarketDatasetsContainer type={menuType} hideSearch={hideSearch} />
        ) : menuType === "manage jobs" ? (
          <MarketManagementContainer type={menuType} hideSearch={hideSearch} />
        ) : (
          <MarketOverviewContainer setType={updateMenuType} />
        )}
      </div>
    </div>
  );
};

export default Market;
